export const apiUrls = {
  login: '/customer/api/login',
  logout: '/customer/api/logout',
  signUp: '/customer/api/signUp',

  productSave: '/customer/api/product/save',
  productDelete(type, id) {
    return '/customer/api/product/' + type + '/' + id
  },

  productPriceWatch: '/customer/api/product/price-watch/save',
  deleteProductPriceWatch(id) {
    return '/customer/api/product/price-watch/' + id
  },

  productSimilarAlerts: '/customer/api/product/similar-alert/save',
  prodocutSimilarAlertsDelete(type, id) {
    return '/customer/api/product/similar-alert/' + type + '/' + id
  },

  productSearchSave: '/customer/api/search/save',
  deleteSearch(id) {
    return `/customer/api/search/${id}`
  }
};

//add favorite
export function createProductSaveParams(data, callback, analyticsData) {

  analyticsData.loginWay = 4

  return {
    analyticsData,
    url : apiUrls.productSave,
    method: "post",
    data : data,
    callback : callback
  }
}

export function createProductPriceWatchParams(data, callback, analyticsData) {

  analyticsData.loginWay = 4

  return {
    analyticsData,
    url : apiUrls.productPriceWatch,
    method: "post",
    data : data,
    callback : callback
  }
}

export function createProductSimilarAlertsParams(data, callback, analyticsData) {

  analyticsData.loginWay = 4

  return {
    analyticsData,
    url : apiUrls.productSimilarAlerts,
    method: "post",
    data : data,
    callback : callback
  }
}

export function createSaveSearchParams(data, callback, analyticsData) {

  analyticsData.loginWay = 1

  return {
    analyticsData,
    url : apiUrls.productSearchSave,
    method: "post",
    data : data,
    callback : callback
  }
}

export function createOnMyAccountClicked() {
  return {
    analyticsData : {
      loginWay: 0
    },
    redirect: '/customer'
  }
}

export function createSeeServiceHistoryParamsClicked(analyticsData) {

  analyticsData.loginWay = 3

  return {
    analyticsData
  }
}

export function createSeePriceParamsClicked(analyticsData) {

  analyticsData.loginWay = 2

  return {
    analyticsData
  }
}



// WEBPACK FOOTER //
// ./resources/js/data/OnLoginActionParams.js